<template>
  <div>
    <app-table :id="tableId" :options="options" @action="getListAction" />
    <corrective-actions-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :additional="additional"
      @close-modal="closeAddEditModal"
      modalId="modal-add-edit"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  extends: CoreLibrary,
  name: "corrective-actions-form",
  mixins: [FormMixin, TableHelpers],
  props: {
    evaluationId: String,
  },

  data() {
    return {
      additional: 0,
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "pending-list",
      rowData: {},
      option: 0,
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      options: {
        url: `${actions.REVIEW_DOCUMENTARY_REPORT}/index`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Ver archivo"),
            icon: "file",
            type: "none",
            component: "corrective-actions-modal",
            modalId: "corrective-add-edit-modal",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.$hub.$on("reload-table", this.reloadTable);
    this.options.columns = [...this.tableColumns, this.actionObj];
    // this.data();
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.REVIEW_DOCUMENTARY_REPORT}`;
    },
    reloadTable: function () {
      this.$hub.$emit("reload-" + this.tableId);
    },
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#corrective-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    /**
     * $emit form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Designar equipo evaluador") {
      } else if (actionObj.title == this.$t("Ver archivo")) {
        window.open(this.rowData.report_documentary_evaluation.full_url, '_blank');
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * cancelled $emit form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  },
};
</script>